window.initInventorySync = function(changedData) {
  return new Promise((resolve, reject) => {
    console.log("[initInventorySync] Starting inventory sync with data:", changedData);
    
    // If no changed data is provided, you may choose to re-scan or simply resolve.
    if (!changedData || !changedData.length) {
      console.log("[initInventorySync] No changed data to sync.");
      updatevpLoadingModal("No inventory changes to sync.");
      document.getElementById("vp-loading-modal-close").style.display = "inline-block";
      return resolve({ status: "success", message: "No changes to sync" });
    }
    
    // Determine current month automatically.
    const now = new Date();
    const monthNames = ["January","February","March","April","May","June","July","August","September","October","November","December"];
    const monthName = monthNames[now.getMonth()];
    
    // Build the sync URL.
    const syncUrl = "https://script.google.com/macros/s/AKfycbx_4TCLlMS-JI8nI92L1I3VKNeWvbbmVfFXrStJtsCq50oiodZfKvsIjxoWxXr_KHu8fA/exec?mode=sync";
    
    // Build the JSON payload.
    const payload = JSON.stringify({
      mode: "sync",
      vendor_key: window.vendorKey,
      month: monthName,
      additionalData: changedData
    });
    
    console.log("[initInventorySync] Sending payload:", payload);
    
    fetch(syncUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain' },
      body: payload
    })
      .then(response => {
        console.log("[initInventorySync] Received response. Status:", response.status);
        return response.text();
      })
      .then(text => {
        console.log("[initInventorySync] Raw response text:", text);
        let data;
        try {
          data = JSON.parse(text);
        } catch (err) {
          console.warn("[initInventorySync] JSON parse error but status is 200. Raw text:", text);
          data = { status: "success", message: "Sync recorded (JSON parse warning)" };
        }
        console.log("[initInventorySync] Sync complete:", data);
        updatevpLoadingModal("Inventory Sync Complete!");
        document.getElementById("vp-loading-modal-close").style.display = "inline-block";
        resolve(data);
      })
      .catch(error => {
        console.error("[initInventorySync] Error during sync:", error);
        // If error is a TypeError, treat it as success.
        if (error instanceof TypeError) {
          console.warn("[initInventorySync] Detected TypeError, treating as success.");
          updatevpLoadingModal("Inventory Sync Complete!");
          document.getElementById("vp-loading-modal-close").style.display = "inline-block";
          resolve({ status: "success", message: "Sync recorded (TypeError treated as success)" });
        } else {
          updatevpLoadingModal("Error during inventory sync. Please try again.");
          document.getElementById("vp-loading-modal-close").style.display = "inline-block";
          reject(error);
        }
      })
      .finally(() => {
        // Optionally, reset the sync flag after a delay for future syncs.
        setTimeout(() => { window.syncTriggered = false; }, 1000);
      });
  });
};

document.addEventListener('DOMContentLoaded', function() {
  console.log("[DOMContentLoaded] DOM fully loaded. Inventory sync is ready.");
});

// Helper to chain update and sync
function processInventoryUpdateAndSync(cartItems, changedData) {
  return updateInventory(cartItems)
    .then(function(updateResult) {
      console.log("Inventory update result:", updateResult);
      if (!changedData || !changedData.length) {
        if (updateResult.results && updateResult.results.length) {
          changedData = updateResult.results
            .filter(function(result) {
              return result.newInventory !== undefined && !result.error;
            })
            .map(function(result) {
              const matchingItem = cartItems.find(function(item) {
                return item.variant_id === result.variant_id;
              });
              return {
                variant_id: result.variant_id,
                variant_title: matchingItem ? matchingItem.title || "" : "",
                variant_category: matchingItem ? matchingItem.variantCategory || "" : "",
                in_stock: result.newInventory.toString()
              };
            });
          console.log("Fallback changedData built from updateResult:", changedData);
        }
      }
      return window.initInventorySync(changedData);
    })
    .then(function(syncResult) {
      console.log("Inventory sync result:", syncResult);
      // Update the modal text to reflect completion.
      updatevpLoadingModal("Inventory Sync complete!");
      // Hide the loading spinner/modal wheel.
      hideVModalLoader();
      // Ensure the print receipt button remains hidden.
      document.getElementById("print-reciept-button").style.display = "none";
      // Display the modal close button so the user can dismiss the modal.
      document.getElementById("vp-loading-modal-close").style.display = "inline-block";
      return syncResult;
    })
    .catch(function(err) {
      console.error("Error during inventory update or sync:", err);
      updatevpLoadingModal("Error updating inventory. Please try again.");
      hideVModalLoader();
      document.getElementById("vp-loading-modal-close").style.display = "inline-block";
      throw err;
    });
}
